import axios from "axios";

export const countryOfOriginList = async () => {
    try {
        const response = await axios.get("/api/countriesOfOrigin");
        return response;
    } catch (err) {
        console.log(err);
    }
};

export const xirifyEnv = async () => {
    try {
        const response = await axios.get("api/xirify/env");
        return response;
    } catch (err) {
        console.log(err);
    }
};

export const deleteCountryOfOrigin = async (payload) => {
    try {
        const response = await axios.delete(`/api/countriesOfOrigin/deleteCountryOfOrigin/${payload}`);
        return response;
    } catch (err) {
        console.log(err);
    }
}

export const updateCountryOfOrigin = async (payload) => {
    try {
        const response = await axios.patch(`/api/countriesOfOrigin/updateCountryOfOrigin/${payload._id}`, payload);
        return response;
    } catch (err) {
        console.log(err);
    }
}

export const addCountryOfOrigin = async (payload) => {
    try {
        const response = await axios.post(`/api/countriesOfOrigin/createCountryOfOrigin`, payload);
        return response;
    } catch (err) {
        console.log(err);
    }
}

